import { takeLatest, call, put } from 'redux-saga/effects';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import logger from 'helpers/logger';
import { actionTypes, requestType } from './constants';
import { actionTypes as actionTypesGatewayAssets } from '../../constants';
import { activateDeactivateGatewayAction, lastCommandStatusActivateRemoteConnectionAction } from './actions';
import { notify } from 'sharedComponents/GeneralNotification';
import { translate } from 'helpers/translateHelper';

function* activateDeactivateGateway({ gatewayId, datacollectionUnitId, isActivate }) {
    yield put(activateDeactivateGatewayAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.activateDeactivateGateway, gatewayId, datacollectionUnitId, isActivate);
        yield put(activateDeactivateGatewayAction(apiCallStatus.SUCCESS, response));
        if (response?.remoteCommandResponse?.requestType === requestType.DEACTIVATED_REMOTE_CONNECTION) {
            notify(translate('ABB.Powertrain.Frontend.gatewayRemoteConnectionDeactivated'), NOTIFICATION_TYPES.SUCCESS);
        } else if (response?.remoteCommandResponse?.requestType === requestType.ACTIVATED_REMOTE_CONNECTION) {
            notify(translate('ABB.Powertrain.Frontend.gatewayRemoteConnectionActivated'), NOTIFICATION_TYPES.SUCCESS);
        }
        yield put({
            type: actionTypesGatewayAssets.GET_GATEWAY_CONNECTED_ASSETS,
            payload: { gatewayID: gatewayId }
        });

        yield put({
            type: actionTypes.LAST_COMMAND_ACTIVATE_ACTION,
            gatewayId,
            requestType: requestType.ACTIVATED_REMOTE_CONNECTION // Can use either type, API returns latest command
        });

        logger.debug('Activate/Deactivate Gateway successfully triggered for page ');
    } catch (err) {
        yield put(activateDeactivateGatewayAction(apiCallStatus.ERROR, [], err));
        notify(err?.message, NOTIFICATION_TYPES.ERROR, true);
    }
}

function* lastCommandStatusActivateRemoteConnection({ gatewayId, requestType }) {
    yield put(lastCommandStatusActivateRemoteConnectionAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.lastCommandStatusActivateRemoteConnection, gatewayId, requestType);
        yield put(lastCommandStatusActivateRemoteConnectionAction(apiCallStatus.SUCCESS, response));
        logger.debug('lastCommandStatusActivateRemoteConnectionAction successfully triggered for page ');
    } catch (err) {
        yield put(lastCommandStatusActivateRemoteConnectionAction(apiCallStatus.ERROR, [], err));
        notify(err?.message, NOTIFICATION_TYPES.ERROR, true);
    }
}

export function* activateDeactivateGatewayWatchers() {
    yield takeLatest(actionTypes.ACTIVATE_DEACTIVATE_GATEWAY, activateDeactivateGateway);
}

export function* lastCommandStatusActivateRemoteConnectionWatchers() {
    yield takeLatest(actionTypes.LAST_COMMAND_ACTIVATE_ACTION, lastCommandStatusActivateRemoteConnection);
}
